import React, { useEffect, useState } from 'react';
import CommonTable from 'components/common/CommonTable'; // Adjust the path as per your setup
import { Box, Button, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { Icon } from '@iconify/react';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import { axios } from 'utils/axios';
import FiltersDrawer from 'components/_dashboard/contact/FilterDrawer';
import { CheckCircle, Cancel, Apartment } from '@mui/icons-material';
import CompanyFilterDrawer from 'components/_dashboard/company/companyDrawer';
import useSettings from 'hooks/useSettings';
import { Container } from '@mui/material';

const defaultFilters = {
  search: '',
  pageSize: 10,
  companyReference: '',
  companyName: '',
  defaultCompany: '',
  disposalSite: '',
  vatRegistrationNumber: '',
  companyRegistrationNumber: ''
};
const Companies = () => {
  const navigate = useNavigate();
  const { themeStretch } = useSettings();

  const [contacts, setContacts] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState(defaultFilters);

  const { enqueueSnackbar } = useSnackbar();

  const [totalRows, setTotalRows] = useState(0);

  const fetchContacts = async (isClear?: boolean) => {
    setLoading(true);
    try {
      // Use default filters if isClear is true, otherwise use current filters
      const appliedFilters: any = isClear ? defaultFilters : filters;
      const query = new URLSearchParams({
        page: page.toString(),
        ...Object.entries(appliedFilters)
          .filter(([key, value]) => value !== '' && value !== null && value !== undefined)
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
      }).toString();

      // const response = await axios.get(`/rest/api/contacts/info?${query}`, {
      //   withCredentials: true
      // });
      const response = await axios.get(`/rest/api/company/info?${query}`, {
        withCredentials: true
      });
      // const data = response.data.data.records || [];
      const data = response.data.data.records.map((item: any) => ({
        ...item,
        Id: item.COMPANY_ID // Ensure Id is mapped
      }));
      setContacts(data);
      setTotalRows(response.data.data.pageMeta.totalRecords || 0);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, [page, pageSize]);

  const columns = [
    { field: 'COMPANY_REFERENCE', headerName: 'Company Reference', flex: 1, minWidth: 250 },
    { field: 'COMPANY_NAME', headerName: 'Company Name', flex: 1, minWidth: 200 },
    { field: 'ALT_TELEPHONE', headerName: 'Telephone No', flex: 1, minWidth: 250 },
    { field: 'MAIN_TELEPHONE', headerName: 'Main Contact', flex: 1, minWidth: 200 },

    {
      field: 'DEFAULT_COMPANY',
      headerName: 'Default Company',
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) =>
        params ? <CheckCircle color="success" /> : <Cancel color="error" />
    },
    {
      field: 'DISPOSAL_SITE',
      headerName: 'Default Disposal Site',
      flex: 1,
      minWidth: 200,
      renderCell: (params: any) =>
        params ? <CheckCircle color="success" /> : <Cancel color="error" />
    },
    { field: 'DEFAULT_BRIDGE_ID', headerName: 'Default Bridge', flex: 2, minWidth: 150 }
  ];

  const handleCreateContact = () => {
    navigate('/dashboard/companies/new');
  };

  const handleRowClick = (params: any) => {
    console.log(params, 'This is the params');
    navigate(`/dashboard/companies/details/${params.row.Id}`);
  };

  const handleEdit = (id: number) => {
    navigate(`/dashboard/companies/edit/${id}`);
  };

  const handleDeleteContact = async (id: number) => {
    try {
      await axios.delete(`/rest/api/company/info/${id}`);
      const newContacts = contacts.filter((el: any) => el.Id !== id);
      setContacts(newContacts);
      enqueueSnackbar('Delete Success', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Delete Failed', { variant: 'success' });
    }
  };

  const clearFilters = () => {
    setFilters(defaultFilters);
    fetchContacts(true);
  };
  return (
    <Container maxWidth={themeStretch ? false : 'lg'}>
      <Box
        sx={{
          padding: 3,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 3
          }}
        >
          <HeaderBreadcrumbs
            heading="Companies"
            links={[
              { name: 'Dashboard', href: '/dashboard' },
              { name: 'Companies', href: '/dashboard/companies' }
            ]}
          />
          <Box
            sx={{
              display: 'flex',
              gap: 2, // Adds spacing between the buttons
              alignItems: 'center'
            }}
          >
            <Button variant="contained" onClick={handleCreateContact} startIcon={<Apartment />}>
              Create Company
            </Button>
            <Tooltip title="Add Filters">
              <Button
                disableRipple
                color="inherit"
                variant="outlined"
                endIcon={<Icon icon={roundFilterList} />}
                onClick={() => setDrawerOpen(true)}
              >
                Filters
              </Button>
            </Tooltip>
          </Box>
        </Box>

        <Box>
          <CommonTable
            rows={contacts}
            columns={columns}
            pageSize={filters.pageSize}
            totalRecords={totalRows}
            loading={loading}
            handlePageChange={(newPage) => setPage(newPage + 1)}
            handlePageSizeChange={(newPageSize) => {
              console.log(newPageSize, 'This is the new pages size');
              setPageSize(newPageSize);
              setFilters({ ...filters, pageSize: newPageSize });
            }}
            onEdit={handleEdit}
            onDelete={(id) => handleDeleteContact(id)}
            onRowClick={handleRowClick}
          />
        </Box>
        <CompanyFilterDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          filters={filters}
          setFilters={setFilters}
          onApply={() => {
            setDrawerOpen(false);
            fetchContacts();
          }}
          onClear={clearFilters}
        />
      </Box>
    </Container>
  );
};

export default Companies;
